export default __webpack_public_path__ + "static/media/javascript.6b108058.png";